const UsersSelectionToolbar = () => (
	<div data-testid="usermanagement-selection-toolbar">Selection</div>
);

export default UsersSelectionToolbar;
